export default {
  NOT_CONNECTED: "NOT_CONNECTED",
  CONNECTED: "CONNECTED",
  WALLET_CONNECTED: "WALLET_CONNECTED",
  WRONG_CHAIN: "WRONG_CHAIN",
};
